import VocEditor from "./src/main"

/* istanbul ignore next */
VocEditor.install = function (Vue) {
  Vue.component(VocEditor.name, VocEditor)
}

export default VocEditor
